import { connect } from 'react-redux';
import ClinicalMedication from './clinical-medication';
import { fetchClinicalMedications } from '../actions';

const mapStateToProps = state => {
  const clinicalMedications   = state.clinicalMedications.medications;

  return {
    fetched:            clinicalMedications.fetched,
    errorMessage:       clinicalMedications.message,
    isLoading:          clinicalMedications.isLoading,
    clinicalMeds:       clinicalMedications.clinicalMeds
  };
};

const mapDispatchToProps = dispatch => ({
  fetchClinicalMedications: memberId => {
    dispatch(fetchClinicalMedications(memberId));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClinicalMedication);
